import React, { useEffect } from "react";
import EditorForTitle from "../tools/EditorForTitle";
import { globalFileServer, globalFileIcon } from "../../../axiosInstance";
import {
  editParameter,
  getFilters,
  ParameterDelete,
  addFilter,
  editFilter,
  addParameter,
} from "../../server/Filter";
import { useDispatch, useSelector } from "react-redux";
import SweetAlert from "sweetalert2";

const Filters = () => {
  const dispatch = useDispatch();
  const filterList = useSelector((state) => state.displayProduct.filterList);

  useEffect(() => {
    dispatch(getFilters());
  }, []);

  const updateFilters = (data) => {
    if (data.itemId === -1) {
      let val = {
        tableName: data.elementTable.TableName,
        name: data.value,
      };
      dispatch(addParameter(val));
    } else {
      let val = {
        id: data.itemId,
        tableName: data.elementTable.TableName,
        name: data.value,
      };
      dispatch(editParameter(val));
    }
  };
  const deleteItem = (id, element) => {
    console.log(element);
    const parameterId = element?.Id;
    const TableName = element?.TableName;

    if (!id || !parameterId) {
      console.error("חסר parameterId או id", { parameterId, id });
      return;
    }

    SweetAlert.fire({
      title: "האם אתה בטוח?",
      text: "האם ברצונך למחוק פריט זה? לא תוכל לשחזר זאת!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#22b09a",
      cancelButtonColor: "#d80028",
      confirmButtonText: "מחק",
      cancelButtonText: "בטל",
    }).then((res) => {
      if (res.value) {
        dispatch(ParameterDelete({ id, parameterId, TableName }));
      }
    });
  };

  return (
    <div className="filters">
      <h1 className="title-role">סינון</h1>
      <div className="flex-container filter-container">
        {filterList.map((element) => {
          return (
            <div className="col-lg-4" key={element.Id}>
              <EditorForTitle
                element={element}
                editItems={(data) => dispatch(editFilter(data))}
                updateItems={(data) => dispatch(editFilter(data))}
                paramName={"Name"}
                dist="filter_types"
              />
              <ul>
                {element.Items.map((e, i) => {
                  return (
                    <li key={i}>
                      <div className="sub-title">
                        <div className="arrow">
                          <img
                            loading="lazy"
                            src={globalFileServer + "iconcss/back.svg"}
                            alt=""
                          />
                        </div>
                        <EditorForTitle
                          elementTable={element}
                          element={e}
                          editItems={(data) => dispatch(editFilter(data))}
                          updateItems={updateFilters}
                          paramName={"Name"}
                          dist="filters"
                        />

                        <div
                          onClick={() => deleteItem(e.Id, element)}
                          className="delete-item"
                        >
                          <div className="img">
                            <img
                              loading="lazy"
                              src={globalFileIcon + "trash.svg"}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
              <div className="add-item">
                <button
                  className="btn"
                  onClick={() => dispatch(addFilter(element.Id))}
                >
                  <img
                    loading="lazy"
                    src={globalFileIcon + "plus.svg"}
                    alt=""
                  />
                  <span>הוסף פילטר</span>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Filters;
